export interface ErrorMessage {
  foutmelding: string,
  headerFoutmelding: string,
  foutmeldingOverig: string,
}
